const ServicesSection = () => {
  return (
    <section className="bg-gradient-to-br from-blue-50 to-white py-10">
      <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            <span className="text-blue-500">Exceptional</span>{' '}
            <span className="text-gray-900">Revenue Cycle Management</span>{' '}
            <span className="text-blue-500">Services</span>
          </h2>
          <p className="text-gray-600 text-base lg:text-lg max-w-4xl mx-auto">
            Our top medical billing company offer a billing services for physician which helps in making your practice operations simpler:
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          
          {/* Left Column - Image Card with fixed width */}
          <div className="lg:w-[350px] flex-shrink-0 bg-gradient-to-br from-blue-100 to-blue-50 rounded-3xl p-8 flex flex-col justify-between">
            <div className="flex-1 flex items-center justify-center mb-6">
              <img 
                src="/billing7.webp" 
                alt="Healthcare Revenue Cycle Management" 
                className="w-full h-auto object-contain rounded-2xl"
              />
            </div>
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-gray-800">
                Healthcare Revenue Cycle Management
              </h3>
              <button className="flex items-center text-blue-600 font-semibold hover:text-blue-600 transition-colors">
                View All Services
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
            </div>
          </div>

          {/* Service Cards - Right side with flex-1 to take remaining space */}
          <div className="flex-1 grid md:grid-cols-3 gap-6">
            {/* Medical Billing Services */}
            <div className="bg-blue-50 rounded-2xl p-6 shadow-sm hover:shadow-xl hover:scale-105 transition-all duration-300 border-l-4 border-blue-600">
              <div className="flex flex-col items-center text-center space-y-3">
                <div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center">
                  <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                    <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="text-base font-bold text-blue-800 mb-2">Medical Billing Services</h4>
                  <p className="text-gray-600 text-xs leading-relaxed">
                    We handle your medical billing properly and effectively, so your practice gets paid faster.
                  </p>
                </div>
              </div>
            </div>

            {/* AR Management Services */}
            <div className="bg-blue-50 rounded-2xl p-6 shadow-sm hover:shadow-xl hover:scale-105 transition-all duration-300 border-l-4 border-blue-600">
              <div className="flex flex-col items-center text-center space-y-3">
                <div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center">
                  <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="text-base font-bold text-blue-800 mb-2">AR Management Services</h4>
                  <p className="text-gray-600 text-xs leading-relaxed">
                    Experts manage Medicare and Medicaid accounts receivable for smoother reimbursement.
                  </p>
                </div>
              </div>
            </div>

            {/* Medical Coding */}
            <div className="bg-blue-50 rounded-2xl p-6 shadow-sm hover:shadow-xl hover:scale-105 transition-all duration-300 border-l-4 border-blue-600">
              <div className="flex flex-col items-center text-center space-y-3">
                <div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center">
                  <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="text-base font-bold text-blue-800 mb-2">Medical Coding</h4>
                  <p className="text-gray-600 text-xs leading-relaxed">
                    Our medical coders assign precise ICD-10 and CPT code to reduce coding errors.
                  </p>
                </div>
              </div>
            </div>

            {/* Medical Billing Audit */}
            <div className="bg-blue-50 rounded-2xl p-6 shadow-sm hover:shadow-xl hover:scale-105 transition-all duration-300 border-l-4 border-blue-600">
              <div className="flex flex-col items-center text-center space-y-3">
                <div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center">
                  <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="text-base font-bold text-blue-800 mb-2">Medical Billing Audit</h4>
                  <p className="text-gray-600 text-xs leading-relaxed">
                    Comprehensive audits protect your revenue by identifying and resolving billing issues.
                  </p>
                </div>
              </div>
            </div>

            {/* Provider Credentialing */}
            <div className="bg-blue-50 rounded-2xl p-6 shadow-sm hover:shadow-xl hover:scale-105 transition-all duration-300 border-l-4 border-blue-600">
              <div className="flex flex-col items-center text-center space-y-3">
                <div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center">
                  <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="text-base font-bold text-blue-800 mb-2">Provider Credentialing</h4>
                  <p className="text-gray-600 text-xs leading-relaxed">
                    Our credentialing team guarantees precise provider enrollment for timely reimbursements.
                  </p>
                </div>
              </div>
            </div>

            {/* Denial Management */}
            <div className="bg-blue-50 rounded-2xl p-6 shadow-sm hover:shadow-xl hover:scale-105 transition-all duration-300 border-l-4 border-blue-600">
              <div className="flex flex-col items-center text-center space-y-3">
                <div className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center">
                  <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="text-base font-bold text-blue-800 mb-2">Denial Management</h4>
                  <p className="text-gray-600 text-xs leading-relaxed">
                    Reduce revenue loss and improve cash flow with our professional denial management services.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
